export default __webpack_public_path__ + "1bb7ee255a42d9742cbd30cfa8959a5b.png";